import { axiosInstance } from "api/axios-config/axios-config";
import { ChangePasswordRequest } from "api/models/request/profile";
import { IUserProperties } from "mobx-stores/_models/user-roles/user";

class ProfileBussiness {
  readonly url = "/api/my-profile";

  public getProfile = async () => {
    var res = await axiosInstance.get<IUserProperties>(this.url);
    return res.data;
  };

  public changePassword = async (changePWReq: ChangePasswordRequest) => {
    var res = await axiosInstance.post(
      this.url + "/change-password",
      changePWReq
    );
    return res.data;
  };

  public async getGrantedPermissions() {
    var res = await axiosInstance.get<string[]>(
      this.url + "/granted-permissions"
    );
    return res.data;
  }
}
export const profileBussiness = new ProfileBussiness();
